import React, { useEffect, useState } from "react";
import InboxTable from "./InboxTable";
import { OBPSService } from "../../../../../../../libraries/src/services/elements/OBPS";
import { Loader, Toast } from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Col, Container, Row } from "react-bootstrap";
import InputContainer from "../../../citizen/TCPForms/layout/inputContainer";
import ButtonWrapper from "../../../citizen/AVPForms/components/Button";

function SummaryDetail({ setApiData, apiData, newApiData, selectedModule, setSelectedModule }) {
  const userInfo = Digit.UserService.getUser();
  let tenantId = Digit.ULBService.getCurrentTenantId();
  let userType = userInfo?.info?.roles?.some((role) => role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN")
    ? "SuperAdmin"
    : userInfo?.info?.roles?.some((role) => role.code === "HRMS_ADMIN")
    ? "Admin"
    : null;
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const location1 = userDetails?.location1?.length > 1 ? userDetails?.location1?.concat(" Development Authority") : null;

  const { control, reset, watch, setValue, handleSubmit } = useForm();

  const { t } = useTranslation();
  if (userType) {
    tenantId = Digit.ULBService.getStateId();
  }
  const [isLoading, setIsLoading] = useState(true);
  const [showToast, setShowToast] = useState(null);
  const [modules, setModules] = useState([]);

  useEffect(() => {
    if (newApiData && newApiData?.moduleNames && newApiData?.moduleNames?.length > 0) {
      setModules(
        newApiData?.moduleNames?.map((item) => {
          return {
            label: item,
            value: item,
          };
        })
      );
    }
  }, [newApiData]);

  const fetchData = async (tenantId, params) => {
    setIsLoading(true);
    setShowToast(null);
    try {
      const result = await OBPSService.applicationReportMISData(tenantId, params);

      if (!result) {
        throw new Error("No data received from server");
      } else if (result?.MisData?.length === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "No Records Found",
        });
      }
      setApiData(result);
    } catch (err) {
      console.error("Error fetching data:", err);
      // handle API error message if available
      const message = err?.response?.data?.message || err?.message || "Something went wrong while fetching data";
      setShowToast({
        key: "true",
        error: true,
        message: message,
      });
      setApiData(null);
    } finally {
      setIsLoading(false);
    }
  };

  const closeToast = () => {
    setShowToast(null);
  };

  const handleFormSubmit = (formData) => {
    let { modulename } = formData;
    // if (modulename === "Plinth Submission") {
    //   modulename = "plinth_submission";
    // } else if (modulename === "Map Compounding") {
    //   modulename = "FORM_MAP_COMPOUNDING";
    // } else if (modulename === "Purchasable Map Submission") {
    //   modulename = "PURCHASABLE_MAP";
    // }
    // try {
    //   await fetchData(tenantId, { developmentAuthorityName, modulename, createdFrom, createdTo });
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    // }
    setSelectedModule(modulename);
  };

  useEffect(() => {
    const fetchDataOnMount = async () => {
      await fetchData(tenantId, { developmentAuthorityName: location1 });
    };
    fetchDataOnMount();
  }, [tenantId]);

  return (
    <div>
      <section className="groupContainer2">
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="formContainer">
            <div className="formHeaderContainer"></div>
            <Container fluid className="formInputContainer common-app-form">
              <Row>
                <Col>
                  <InputContainer
                    label="Module Name"
                    control={control}
                    placeholder="Select Module Name"
                    data={modules}
                    name="modulename"
                    type="selectInput"
                  />
                </Col>
                <Col></Col>
              </Row>
            </Container>
          </div>
          <div className="footerContainer2">
            <div className="buttonWrapper" style={{ display: "flex", gap: "8px" }}>
              <ButtonWrapper variant="contained" color="success" size="medium" label="Search" type="submit" />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Reset"
                onClick={() => {
                  reset();
                  setSelectedModule("");
                }}
              />
            </div>
          </div>
        </form>
      </section>

      {/* <FilterForm onSubmit={handleFormSubmit} userDetails={userDetails} userType={userType} location1={location1}/> */}
      {isLoading && (
        <div>
          <Loader />
        </div>
      )}
      {!isLoading && showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}

      {!isLoading && !showToast && apiData && <InboxTable apiData={apiData} location1={location1} newApiData={newApiData} />}
    </div>
  );
}

export default SummaryDetail;
